import { useState, useEffect, useContext, useRef } from "react";
import { Instruction, Instructions } from "../../utils/types";
import InstructionManager from "../views/InstructionManager";
import { InstructionsAreaProps } from "../../utils/props";
import { UserContext } from "../../context/UserContext";
import { PLACE_HOLDER } from "../../utils/templates";
import { RecipeContext } from "../../context/RecipeContext";
import { DataContext } from "../../context/DataContext";

/** Triggers creation of input if there are no inputs left (num of inputs = array index)
 * This doesn't work with refactoring of PLACE_HOLDER instructions
 */
const HAS_NO_REMAINING_INPUT = (inputs: number, arrayKey: number) =>
  inputs - 1 === arrayKey;

/** InstructionsArea handles selected instruction - updates GrandParent recipe state
 *
 * Dynamically renders list of instructions - filters out selected options (WIP)
 *
 * InstructionsRequests -> InstructionsArea -> InstructionManager
 */
function InstructionsArea({
  onInstructionInput,
  onInstructionRequest,
}: InstructionsAreaProps) {
  const { isBookSource } = useContext(DataContext);
  const { userId, currentBookId } = useContext(UserContext);
  const { requestAction, selectedRecipe } = useContext(RecipeContext);
  const [selectedInstructions, setSelectedInstructions] =
    useState<Instructions>(
      requestAction.edit
        ? [
            ...selectedRecipe.instructions,
            { id: null, instruction: "some instruction..." },
          ]
        : PLACE_HOLDER,
    );

  const instructionsAreaRef = useRef<HTMLDivElement>(null);

  /** Create additional input field for new instruction */
  function createInstructionInput() {
    setSelectedInstructions((selected) => [
      ...selected,
      { id: null, instruction: "some instruction..." },
    ]);
  }

  /** Update list of selected instructions */
  async function updateSelected(instruction: Instruction, arrayKey: number) {
    setSelectedInstructions((i: Instruction[]) => {
      const updatedInstructions = [...i];
      updatedInstructions[arrayKey] = instruction;
      return updatedInstructions;
    });
    // Recipe form is rendering global user instructions - on select instruction is associated to selected book
    if (isBookSource)
      onInstructionRequest.associate(userId, currentBookId, +instruction.id);

    if (HAS_NO_REMAINING_INPUT(selectedInstructions.length, arrayKey))
      createInstructionInput();
  }

  /** Remove unselected instruction */
  function removeSelected(instructionKey: number) {
    setSelectedInstructions((instructions) => {
      const alteredInstructions = [...instructions];
      alteredInstructions[instructionKey] = PLACE_HOLDER[instructionKey] || {
        id: null,
        instruction: "some instruction...",
      };
      return alteredInstructions;
    });
  }

  /** Remove unselected filter key */
  // function removeFilterKey(arrayKey: number) {
  //   setFilterKeys(keys => {
  //     const updatedKeys = { ...keys }
  //     delete updatedKeys[arrayKey]
  //     return updatedKeys;
  //   })
  // }

  /** Constructs key value pair of filters keys with array id & option id and updates filter keys */
  // function updateFilterKeys(keys: number[]) {
  //   setFilterKeys(prevKeys => {
  //     const updatedKeys = { ...prevKeys }
  //     const newKeySet = { [keys[0]]: keys[1] }
  //     return { ...updatedKeys, ...newKeySet }
  //   })
  // }

  /** Consolidates logic that adds instructions */
  const handleSelected = {
    // addInstruction,
    // addCreated,
    createInput: createInstructionInput,
    updateSelected,
    // updateFilterKeys,
    removeSelected,
    // removeFilterKey
  };

  /** Updates parent state of instructions when instructions is changed and on mount */
  useEffect(() => {
    onInstructionInput(
      selectedInstructions.filter((i) => i.id),
      "instructions",
    );
  }, [selectedInstructions]);
  return (
    <div
      ref={instructionsAreaRef}
      id="InstructionsArea"
      className="min-h-0 overflow-y-auto h-full block w-full rounded-md border-2 border-accent-secondary pb-2 px-2 shadow-sm sm:leading-6"
    >
      {selectedInstructions.map((value, index) => (
        <InstructionManager
          key={index}
          arrayKey={index}
          numOfInstruction={selectedInstructions.length}
          instruction={value}
          handleSelected={handleSelected}
          handleInstruction={onInstructionRequest}
        />
      ))}
      {/* <>
        <div className="parent h-80">
          {isRender && (
            <>
              <div className="child 1 overflow-y-scroll h-full"></div>
              <div className="child 2 overflow-y-scroll h-full"></div>
            </>
          )}
          <div className="child 3"></div>
        </div>
      </> */}
    </div>
  );
}

export default InstructionsArea;
